export { BaselineComponent } from './baseline.component';
export { Remediate } from './remediate';
export const href =
    'https://learn.microsoft.com/en-us/defender-office-365/safe-attachments-for-spo-odfb-teams-configure';
